var map = null;

function initializeMap(targetEl, lat, lng, zoom) {
  var target = targetEl && targetEl[0] ? targetEl[0] : $('.map__canvas')[0];
  var lat = lat || 49.260635;
  var lng = lng || 10.986328;
  var latlng = new google.maps.LatLng(lat, lng);
  var mapOptions = {
    zoom: zoom || 6.4,
    center: latlng,
    mapTypeId: google.maps.MapTypeId.TERRAIN,
    streetViewControl: false,

    // Diable all to create screenshow
    disableDefaultUI: true
  };
  map = new google.maps.Map(target, mapOptions);
}

var markers = [];
var mapMarkers = [];

function placeMarker(project) {
  var icon = {
    path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    fillColor: '#395f56',
    fillOpacity: 1,
    anchor: new google.maps.Point(13, 23),
    strokeWeight: 2,
    strokeColor: '#fff',
    scale: 2
  };

  var loc = new google.maps.LatLng(project.lat, project.lng);

  var marker = new google.maps.Marker({
    position: loc,
    map: map,
    title: project.title ? project.title : null
  });

  marker.setIcon(icon);

  var infowindow = null;

  if (project.title) {
    var html = '<div class="map-info-window__wrapper">';
    html += '<div class="map-info-window__container">';
    if (project.image && project.image.filename_small) {
      html +=
        '<div class="map-info-window__image" style="background-image: url(\'/image/' +
        project.image.filename_small +
        '\')"></div>';
    }
    html += '<div class="map-info-window__content">';
    project.url &&
      (html += '<a class="map-info-window__link" href="' + project.url + '">');
    html += '<h5>' + project.title + '</h5>';
    project.url && (html += '</a>');
    if (project.subtitle) {
      html +=
        '<div class="map-info-window__subtitle">' + project.subtitle + '</div>';
    }
    project.url &&
      (html +=
        '<a class="map-info-window__read-more-link" href="' +
        project.url +
        '">Zum Projekt <span>›</span></a>');
    html += '</div>';
    html += '</div>';
    html += '</div>';

    infowindow = new google.maps.InfoWindow({ content: html });

    google.maps.event.addListener(marker, 'click', function () {
      for (var i = 0; i < markers.length; i++) {
        var _marker = markers[i];
        try {
          _marker.infowindow.close();
        } catch (e) {}
      }
      infowindow.open(map, marker);
    });
  }

  mapMarkers.push(marker);
  markers.push({ marker: marker, infowindow: infowindow });
}

function setMapOnAll(map) {
  for (var i = 0; i < markers.length; i++) {
    mapMarkers[i].setMap(map);
  }
}

function clearMarkers() {
  setMapOnAll(null);
}

function deleteMarkers() {
  clearMarkers();
  markers = [];
  mapMarkers = [];
}

function placeMarkers(markers) {
  $.each(markers ? markers : mapProjects, function (index, item) {
    placeMarker(item);
  });
}

function loadMap(targetEl, markers, lat, lng, zoom) {
  let scriptEl = document.createElement('script');
  scriptEl.setAttribute(
    'src',
    'https://maps.google.com/maps/api/js?key=AIzaSyCeHV0vw0o_zwVT_nxtkXQhC90eegIHg0U'
  );
  document.body.appendChild(scriptEl);

  scriptEl.addEventListener('load', function () {
    initializeMap(targetEl, lat, lng, zoom);
    placeMarkers(markers);
  });
}

function acceptGoogleMaps() {
  localStorage.setItem('googleMapsAccepted', 1);
  $('body').addClass('google-maps-accepted');
}

function createMapAcceptNotice(targetEl, markers, lat, lng, zoom) {
  var wrapper = $(
    '<div class="dsgvo__accept-wrapper dsgvo__accept-wrapper--map"/>'
  );
  wrapper.appendTo(targetEl);

  var container = $('<div class="dsgvo__accept-container"/>');
  container.appendTo(wrapper);

  var contentContainer = $('<div class="dsgvo__accept-content">');
  contentContainer.appendTo(container);

  var title = $('<div class="dsgvo__accept-title">');
  title.html('Karte anzeigen');
  title.appendTo(contentContainer);

  var text = $('<div class="dsgvo__accept-text">');
  text.html(
    'Wenn Sie auf "Karte anzeigen" klicken, wird eine Verbindung zu Google Inc. hergestellt. Dabei werden Daten an Google übertragen. Weitere Infos finden Sie auf unserer <a href="/datenschutz">Datenschutz Seite</a>.'
  );
  text.appendTo(contentContainer);

  var button = $('<div class="dsgvo__accept-button">');
  button.html('Karte anzeigen');
  button.on('click', function () {
    acceptGoogleMaps();
    $('.dsgvo__accept-wrapper--map').remove();
    loadMap(targetEl, markers, lat, lng, zoom);
  });
  button.appendTo(contentContainer);
}

$(function () {
  if (localStorage.getItem('googleMapsAccepted')) {
    if ($('.map__canvas').length) {
      loadMap();
    }
  } else {
    var mapCanvas = $('.map__canvas');
    createMapAcceptNotice(mapCanvas);
  }
});
